import { useQuery } from '@tanstack/react-query'
import { useAlertService } from '@/shared/lib/useAlertService'
import { AlternativeContactList } from '@/modules/parent/alternative-contact-page/type'
import { AlternativeContactsService } from '@/shared/api/rest/services/alternative-contacts.service'

export function useAlternativeContactList(id: string): {
    alternativeContact: AlternativeContactList | undefined
    loading: boolean
    error: Error | undefined
    refetch: () => void
} {
    const alertService = useAlertService()
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['alternative-contacts', id],
        enabled: !!id,
        queryFn: async () => {
            try {
                return (await AlternativeContactsService.byParent(
                    id
                )) as unknown as AlternativeContactList
            } catch (err) {
                alertService.error(
                    err instanceof Error ? err.message : 'Failed to load contacts'
                )
                throw err
            }
        }
    })

    return {
        alternativeContact: data,
        loading: isLoading,
        error: error ?? undefined,
        refetch
    }
}
